<template>
	<!-- Topbar Start -->
	<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
		<div class="container-fluid">
			<!-- LOGO -->
			<a href="/" class="navbar-brand mr-0 mr-md-2 logo">
				<span class="logo-lg">
					<img src="@assets/images/logo.png" alt height="40" />
<!--					<span class="d-inline h5 ml-2 text-logo">AVATAR</span>-->
				</span>
				<span class="logo-sm">
					<img src="@assets/images/logo.png" alt height="40" />
<!--          <span class="d-inline h5 ml-2 text-logo">AVATAR</span>-->
				</span>
			</a>

			<ul
				class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0 ml-5"
			>
				<li class>
					<button
						class="button-menu-mobile open-left"
						:class="{ open: isMenuOpened }"
						@click="toggleMenu"
					>
						<feather v-if="this.$parent.isMobileMenuOpened === false" type="menu" class="menu-icon align-middle"></feather>
						<feather v-if="this.$parent.isMobileMenuOpened === true" type="x" class="close-icon"></feather>
					</button>
				</li>
			</ul>

			<ul
				class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0"
			>
				<li class="d-none d-sm-block">
					<div class="app-search">
						<form>
							<div class="input-group">
								<input
									type="text"
									class="form-control"
									placeholder="Search..."
								/>
								<feather type="search" class="align-middle"></feather>
							</div>
						</form>
					</div>
				</li>

				<b-nav-item-dropdown
					v-if="notifications.length > 0"
					id="bell-notification"
					right
					variant="white"
					class="notification-list"
					:title="notificationsInfo"
					menu-class="dropdown-lg"
				>
					<template v-slot:button-content>
						<feather type="bell" class="align-middle"></feather>
						<span class="noti-icon-badge"></span>
					</template>
					<b-tooltip target="bell-notification" placement="left"
						>{{ notificationsInfo }}</b-tooltip
					>
					<!-- item-->
					<b-dropdown-text class="noti-title border-bottom pb-2" tag="div">
						<h5 class="m-0 font-size-16"> Notifications </h5>
					</b-dropdown-text>

					<b-dropdown-text
						href="javascript:void(0);"
						class="notify-item border-bottom"
						v-for="(item, index) in notifications"
						:key="index"
					>
						<div class="notify-icon bg-primary">
							<i class="uil"
								:class="notifIcon(item.type)"></i>
						</div>
						<p class="notify-details">
							<a href="" @click.prevent="doReadNotification(item.id)">
								<template class="mb-0" v-if="item.message.length >= 40">{{ item.message.substring(0,40) + '...' }}</template>
								<template class="mb-0" v-else>{{ item.message }}</template>
							</a>
							<small class="text-muted">{{ item.createAt }}</small>
						</p>
					</b-dropdown-text>
				</b-nav-item-dropdown>

        <li v-else>
          <a
              href="#"
              class="nav-link right-bar-toggle toggle-right"
							v-b-tooltip.hover
							:title="notificationsInfo">
            <feather type="bell" class="align-middle"></feather>
          </a>
        </li>
        <li
            id="logout-tooltip"
            class="dropdown notification-list"
            title="Log Out"
        >
          <a
              href="#"
              class="nav-link right-bar-toggle toggle-right"
			  @click.prevent="doLogout"
          >
            <feather
                type="log-out"
                class="icon-dual icon-xs mr-2 align-middle"
            ></feather>
          </a>
          <b-tooltip target="logout-tooltip" placement="left"
          >Log Out</b-tooltip
          >
        </li>
			</ul>
		</div>
	</div>
	<!-- end Topbar -->
</template>

<script>
import _ from 'lodash'
import { authComputed, authMethods, notificationsActions } from '@state/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
	components: {
		VuePerfectScrollbar,
	},
	props: {
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		isMenuOpened: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			notifications: [],
		}
	},
	computed: {
		...authComputed,
		notificationsInfo() {
			if (Array.isArray(this.notifications) && this.notifications.length > 0) {
				return `${ this.notifications.length } new unread notifications`
			}

			return `You don't have any notifications yet.`
		}
	},
	created() {
    this.doReadNotification = _.debounce(
      this.doReadNotification,
      1000
    )
	},
	mounted() {
		this.fetchNotifications()
	},
	methods: {
		...authMethods,
		...notificationsActions,
		doLogout() {
			this.logOut()
			this.$router.push({ name: 'login'})
		},
		toggleMenu() {
			this.$parent.toggleMenu()
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar()
		},
		notifIcon(type) {
			let stringType = type.replace('_', ' ').toLowerCase()
			
			if (stringType.includes('certificate')) {
				return 'uil-file-alt'
			}
			
			return 'uil-bell'
		},
		async fetchNotifications () {
      const params = { page: 1 }

      const res = await this.getNotifications(params)

      if (res.status == 'success') {
        const { data, pagination } = res
        this.notifications = data.filter(item => !item.hasRead)
      } else {
        this.notifications = []
        this.$swal(
          `Oops!`,
          res.data,
          'error'
        )
      }
    },
		async doReadNotification(notificationId) {
      await this.readNotification(notificationId)
      this.fetchNotifications()
			this.$router.push('/me/view')
    },
	},
}
</script>

<style lang="scss">
.noti-scroll {
	height: 220px;
}
.ps > .ps__scrollbar-y-rail {
	width: 8px !important;
	background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
	width: 6px !important;
}
.button-menu-mobile {
	outline: none !important;
}
</style>
